import React from 'react'
import { Textarea as TextareaUI } from './styles'
export const Textarea = React.forwardRef((props, ref) => {
  return <TextareaUI ref={ref} {...props} autoComplete="off" />
})
